import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    rentInformationRef: any
    selectedRentCompany: CustomSingleSelectModel | undefined
    setSelectedRentCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    rentPriceMonthly: string | undefined
    setRentPriceMonthly: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedRentCurrency: CustomSingleSelectModel | undefined
    setSelectedRentCurrency: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    rentEndDate: string | undefined
    setRentEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    rentStartDate: string | undefined
    setRentStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    rentDesc: string | undefined
    setRentDesc: React.Dispatch<React.SetStateAction<string | undefined>>
}

const RentInformation = ({
    rentInformationRef,
    selectedRentCompany,
    setSelectedRentCompany,
    rentPriceMonthly,
    setRentPriceMonthly,
    selectedRentCurrency,
    setSelectedRentCurrency,
    rentEndDate,
    rentStartDate,
    setRentEndDate,
    setRentStartDate,
    rentDesc,
    setRentDesc,
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={rentInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Kiralama Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kiralama Firması</label>

                                <CustomSingleSelect
                                    selectedValue={selectedRentCompany}
                                    onChange={setSelectedRentCompany}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedRentCompany?.value,
                                                isSupplier: true,
                                                onSubmit: async (response) => {
                                                    setSelectedRentCompany({ label: response.name, value: response.companyId })
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Aylık Kiralama Fiyatı / Döviz Cinsi</label>

                                <Box flexDirection="row">
                                    <Box mr="15px" flexGrow={1} justifyContent="center">
                                        <input style={{ border: '1px solid #F1F1F4' }} value={rentPriceMonthly} onChange={(e) => setRentPriceMonthly(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <CustomSingleSelect
                                            selectedValue={selectedRentCurrency}
                                            onChange={setSelectedRentCurrency}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </Box>
                                </Box>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kiralama Başlangıç Tarihi</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={rentStartDate} onChange={(e) => setRentStartDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kiralama Bitiş Tarihi</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={rentEndDate} onChange={(e) => setRentEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <Box height="100%">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kiralama Açıklaması</label>
                                <textarea value={rentDesc} onChange={(e) => setRentDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: '100%', resize: 'none' }} className="form-control form-control-solid" />
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default RentInformation;